const EVENT_TYPES = {
  WebPageView: 'WebPageView',
  Reporting: 'Reporting',
  Desktop: 'Desktop',
  Ereader: 'Ereader',
  UserActionPerformed: 'UserActionPerformed'
};

const SUB_SYSTEMS = {
  CambridgeOne: 'c1'
};

const URL_ENDPOINTS = {
  ServerAnalytics: '/apigateway/cav-analytics',
  ServerAnalyticsBulk: '/apigateway/cav-analytics-bulk'
};

const APP_BASE_URLS = {
  onboarding: '',
  dashboard: '/dashboard',
  class: '/class',
  'learning-path': '/learning-path',
  nlp: '/nlp',
  admin: '/admin',
  ielts: '/ieltsi',
  foc: '/foc',
  desktopApp: '/mobile-gateway'
};
const KAFKA_TOPICS_PREFIX = {
  DesktopPrefix: 'aws.us-west-2.english.analytics.c1desktop.',
  EreaderPrefix: 'aws.us-west-2.english.analytics.ereader.',
  UserActionPerformedPrefix: 'aws.us-west-2.english.analytics.'
};

const KAFKA_TOPICS = {
  WebPageView: 'aws.us-west-2.english.analytics.fct.webpageviews.0',
  Reporting: 'aws.us-west-2.english.analytics.fct.reporting.0'
};

const KAFKA_SUBJECTS = {
  Separator: '-',
  Suffix: 'value'
};

const APP_METADATA = {
  AppVersion: 'v2'
};

const APP_SETTING = {
  SessionStorage: {
    LastVisitedURL: 'comprodls.nemo.lastVisitedURL'
  }
};

module.exports = {
  EVENT_TYPES,
  SUB_SYSTEMS,
  URL_ENDPOINTS,
  APP_BASE_URLS,
  APP_METADATA,
  KAFKA_TOPICS,
  KAFKA_TOPICS_PREFIX,
  KAFKA_SUBJECTS,
  APP_SETTING
};
